// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","fundUpdatePressMediaItem":"QwYvPtZ6lsrzVci9_KKPK","heading":"_3gpYKcrqX4EeO7gDrvvoKb","text":"hkKDyp6T6eRlncm7XJS0J"};